import * as React from 'react'

import { Box, CheckBox, Icon, Text } from '@factorialco/deprecated-design-system'
import isEmpty from 'lodash/isEmpty'

import type TimeoffPolicy from 'modules/timeoff/store/models/TimeoffPolicy/Policy'

interface TimeoffPolicyProps {
  selected: boolean
  timeoffPolicy: TimeoffPolicy
}
interface TimeoffPolicyProfileProps {
  timeoffPolicy: TimeoffPolicy
}

const TimeoffPolicyProfile = ({ timeoffPolicy }: TimeoffPolicyProfileProps) => {
  return (
    <Box alignItems="center" flexDirection="row" flexGrow gap="s12">
      <Box flexDirection="row" justifyContent="spaceBetween" width="full">
        <Box>
          <Text.Normal weight="medium" ellipsis>
            {timeoffPolicy.attributes.name}
          </Text.Normal>
        </Box>
      </Box>
    </Box>
  )
}

const SingleSelectTimeoffPolicy = ({ timeoffPolicy, selected }: TimeoffPolicyProps) => {
  return (
    <Box
      alignItems="center"
      background={selected ? 'grey200' : 'grey000White'}
      cursor="pointer"
      flexDirection="row"
      gap="s16"
      paddingX="s16"
      paddingY="s12"
      width="full"
    >
      <TimeoffPolicyProfile timeoffPolicy={timeoffPolicy} />
      {selected && (
        <Box>
          <Icon.Medium icon="check" />
        </Box>
      )}
    </Box>
  )
}

const MultiSelectTimeoffPolicy = ({ timeoffPolicy, selected }: TimeoffPolicyProps) => {
  const hasOvertimeAllowance = !isEmpty(timeoffPolicy.overtimeAllowances)

  return (
    <Box
      alignItems="center"
      background="grey000White"
      cursor="pointer"
      flexDirection="row"
      gap="s16"
      paddingX="s16"
      paddingY="s12"
      width="full"
      borderRadius={{ bottomLeft: 'abs004', bottomRight: 'abs004' }}
    >
      <Box>
        <CheckBox checked={selected || hasOvertimeAllowance} disabled={hasOvertimeAllowance} />
      </Box>
      <TimeoffPolicyProfile timeoffPolicy={timeoffPolicy} />
    </Box>
  )
}

interface Props {
  timeoffPolicy: TimeoffPolicy
  selected: boolean
  onSelectMultiple: ((selectedIds: string[]) => void) | null
  onSelectTimeoffPolicy: (policy: TimeoffPolicy) => () => void
}

export default function Item({
  timeoffPolicy,
  selected,
  onSelectMultiple,
  onSelectTimeoffPolicy,
}: Props) {
  const _TimeoffPolicyComponent = onSelectMultiple ? (
    <MultiSelectTimeoffPolicy timeoffPolicy={timeoffPolicy} selected={selected} />
  ) : (
    <SingleSelectTimeoffPolicy timeoffPolicy={timeoffPolicy} selected={selected} />
  )

  return (
    <Box onClick={onSelectTimeoffPolicy(timeoffPolicy)} width="full">
      {_TimeoffPolicyComponent}
    </Box>
  )
}
